import { render } from "./DeleteRoleModal.vue?vue&type=template&id=97ed1dc2&scoped=true"
import script from "./DeleteRoleModal.vue?vue&type=script&lang=js"
export * from "./DeleteRoleModal.vue?vue&type=script&lang=js"

import "./DeleteRoleModal.vue?vue&type=style&index=0&id=97ed1dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ed1dc2"]])

export default __exports__